import { EditType } from './EditType';

export function ErrorCodeResolutionAction(x: string): EditType {
  if (x == 'SERVICE-MULTIPARCEL-UNSUPPORTED') {
    return 'CONTENTS';
  }

  if (
    x.startsWith('SERVICE-NO-PICKUP-SHOP-AVAILABLE') ||
    x.startsWith('SERVICE-MISSING') ||
    x.startsWith('SERVICE-UNAVAILABLE') ||
    x.startsWith('SERVICE-CHANGE') ||
    x.startsWith('SERVICE-UNSUPPORTED-MARKETPLACE-')
  ) {
    return 'SERVICE';
  }

  if (x.startsWith('EXTRAS-UNAVAILABLE')) {
    return 'EXTRAS';
  }

  if (
    [
      'ITEM-EXPORTREASON-REQUIRED',
      'ITEM-IOSSNUMBER-REQUIRED',
      'ITEM-IOSSNUMBER-FORMAT',
      'SERVICE-DDU-UNSUPPORTED'
    ].includes(x) ||
    x.startsWith('CUSTOMS-RECIPIENT') ||
    x.startsWith('CUSTOMS-SENDER')
  ) {
    return 'CUSTOMS';
  }

  if (x.startsWith('ITEM') || x.startsWith('PRODUCT')) {
    return 'CONTENTS';
  }

  if (x.startsWith('ADDRESS')) {
    return 'ADDRESS';
  }

  return null;
}
